import BasicExtendView from "src/libs/basic-view/BasicExtendView"
import "../assets/css/style.scss"
import TestGeneratorForm from "./generator/TestGeneratorForm"
import TestGeneratorHead from "./generator/TestGeneratorHead"
import TestGenLeft from "./generator/TestGenLeft"

export default class TestGeneratorView extends BasicExtendView {
    props: any  
    head = () : JSX.Element => {
		return <TestGeneratorHead />
	}
    left = ():JSX.Element => {
		return <TestGenLeft />
	}
    center = () => {
        return <TestGeneratorForm {...this.props} />   
    }
}